import { useRef, useState } from 'react';

const useRestoredFocusRing = () => {
  const usedPointer = useRef(false);
  const [hideFocusRing, setHideFocusRing] = useState(false);

  return {
    fieldFocused: hideFocusRing ? false : undefined,
    popupHandlers: {
      onPointerDownCapture: () => {
        usedPointer.current = true;
      },
      onKeyDownCapture: () => {
        usedPointer.current = false;
      },
    },
    onPopupClose: () => setHideFocusRing(usedPointer.current),
    onFieldBlur: () => setHideFocusRing(false),
  };
};

export default useRestoredFocusRing;
